import { types } from "mobx-state-tree";

import { createCustomReadonlyDictionary } from "stores/templates/ReadonlyDictionaryStore";
import api from "services/api";

export const TagDictionaryItem = types.model({
  id: types.number,
  title: types.string,
});

const TagDictionary = createCustomReadonlyDictionary({
  itemModel: TagDictionaryItem,
  fetch: async function() {
    return await api.get(`/tag/slim-list`);
  },
  getValue: value => value,
  getLabel: ({ title }) => title,
});

export default TagDictionary.create();
